// @ts-nocheck
/**
 * Admin+ drawer onboarding steps (data-v-step="1" … "5").
 * @param {object} vm - Vue component instance with $t
 */
export function buildAdminPlusDrawerSteps(vm) {
  const t = (key) => vm.$t(key);
  return [
    {
      target: '[data-v-step="1"]',
      label: t("message.onboarding_academy_settings_label"),
      title: t("message.onboarding_academy_settings_title"),
      autoClick: true,
      icon: require("@/assets/icons/admin+/academy-settings.svg"),
      description: t("message.onboarding_academy_settings_description"),
      before() {
        const element = document.querySelector('[data-v-step="1"]');
        if (element) {
          element.click();
        }
      },
      params: {
        placement: "left-end",
        highlight: true,
      },
    },
    {
      target: '[data-v-step="2"]',
      icon: require("@/assets/icons/admin+/academy_members.svg"),
      label: t("message.onboarding_members_label"),
      title: t("message.onboarding_members_title"),
      autoClick: false,
      before() {
        const element = document.querySelector('[data-v-step="2"]');
        if (element) {
          element.click();
        }
      },
      description: t("message.onboarding_members_description"),
      params: {
        placement: "left-start",
        highlight: true,
      },
    },
    {
      target: '[data-v-step="3"]',
      icon: require("@/assets/icons/admin+/academy_calendar.svg"),
      label: t("message.onboarding_calendar_label"),
      title: t("message.onboarding_calendar_title"),
      autoClick: true,
      description: t("message.onboarding_calendar_description"),
      before() {
        const element = document.querySelector('[data-v-step="3"]');
        if (element) {
          element.click();
        }
      },
      params: {
        placement: "left",
        highlight: true,
      },
    },
    {
      target: '[data-v-step="4"]',
      icon: require("@/assets/icons/admin+/academy_products.svg"),
      label: t("message.onboarding_products_label"),
      title: t("message.onboarding_products_title"),
      autoClick: false,
      description: t("message.onboarding_products_description"),
      before() {
        const element = document.querySelector('[data-v-step="4"]');
        if (element) {
          element.click();
        }
      },
      params: {
        placement: "left",
        highlight: true,
      },
    },
    {
      target: '[data-v-step="5"]',
      icon: require("@/assets/icons/admin+/academy_transactions.svg"),
      label: t("message.onboarding_transactions_label"),
      title: t("message.onboarding_transactions_title"),
      before() {
        const element = document.querySelector('[data-v-step="5"]');
        if (element) {
          element.click();
        }
      },
      autoClick: true,
      description: t("message.onboarding_transactions_description"),
      params: {
        placement: "left",
        highlight: true,
      },
    },
  ];
}
